export const enum DashboardCharts {
  ALL = 'all',
  REPORTS_UPLOADED = 'reportsUploaded',
  REPORTS_STATUSES = 'reportStatuses',
  REPORTS_ACTIONS_TAKEN = 'reportsActionTaken',
  REPORTS_VIEWED_AND_DOWNLOADED = 'reportsViewedDownloaded',
  REPORTS_HOURS_SAVED = 'reportsHoursSaved'
}
